<template>
  <div class="tutorial-initial">
    <h1>
      {{ content.title }}
      <img
        :src="content.image"
        alt="arrow"
      >
    </h1>
    <div class="description-container">
      <p>
        {{ content.description }}
      </p>
      <p class="footer">
        {{ content.footerMessage }}
      </p>
      <tutorial-button
        :action="action"
        :content="content.cta"
      />
    </div>
  </div>
</template>

<script>
import mixin from './tutorialMixin'

export default {
  name: 'TutorialInitial',
  mixins: [mixin]
}
</script>

<style lang="scss">
  .tutorial-initial {
    z-index: 9004;
    position: fixed;
    top: 25%;
    left: 15%;

    .arrow {
      position: fixed;
      transform: translateY(-82%) translateX(-90%);
      width: 25%;
    }

    .description-container {
      width: 60%;

      .footer {
        margin-top: 20px;
      }
    }
  }
</style>
